import { useEffect, useRef } from 'react';
import { scrollStore, type ScrollListener, type ScrollState } from './store';

/**
 * Run `listener` for every scrolling frame (and once on mount) without re-rendering the component.
 * The latest `listener` is always used, so callers may pass an inline function.
 */
export function useScrollListener(listener: ScrollListener): void {
  const latest = useRef(listener);
  useEffect(() => {
    latest.current = listener;
  });
  useEffect(() => scrollStore.subscribe((state: ScrollState) => latest.current(state)), []);
}

/** Freeze page scrolling while `active` (dialogs, menus). Works with native and smooth scrolling. */
export function useScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return undefined;
    return scrollStore.lock();
  }, [active]);
}
